import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useWebsiteBlock = () => {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['website-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('website_settings')
        .select('*')
        .order('created_at', { ascending: true })
        .limit(1)
        .single();
      
      if (error) throw error;
      return data;
    },
    refetchInterval: 30000, // Check every 30 seconds
    staleTime: 10000,
  });

  return {
    isBlocked: settings?.is_blocked ?? false,
    isLoading,
    settings,
  };
};
